import React, { useEffect } from 'react';
import BookingFieldsBlock from './BookingFieldsBlock';
import LocationBlock from './LocationBlock';
import Price from './Price';
import TimeZone from '../../components/Common/TimeZone';
import VariantsBlock from './VariantsBlock';
import CustomerInfo from './CustomerInfo';
import { stringToBoolean } from '../../utilities/conversionUtility';

export default function ApptConfirmationPage(props) {
  const {
    canBook,
    closeModal,
    enabledBookingCreation,
    enabledBookingFields,
    enableLocationDropdown,
    enableResourceDropdown,
    getValidationFn,
    googleApiKey,
    locations,
    locale,
    productTitle,
    renderSubmitButton,
    setting,
    selectedLocation,
    selectedResource,
    selectedTimeSlots,
    setWrapperHeight,
    style,
    timeZone,
    timeSlotSelected,
    translation,
    variants,
    dateFormat,
    timeInterval,
  } = props;
  const showLocationMap = stringToBoolean(setting.show_location);
  const selectedTime = timeSlotSelected ? timeSlotSelected.start : null;
  let location = selectedLocation;
  let mapUrl = '';

  if (!location && locations.length === 1) location = locations[0];

  if (location && location.address) {
    const queryArray = location.address.split(',').map((el) => el.trim().replace(' ', '+'));
    mapUrl = `https://www.google.com/maps/embed/v1/place?q=${queryArray.join()}&key=${googleApiKey}`.replace('#', '');
  }

  useEffect(() => setWrapperHeight(), []);

  return (
    <div>
      <button type="button" className="btn-back-title" style={style.body} onClick={closeModal}>
        <i className="fa fa-arrow-left fa-2" aria-hidden="true" />
      </button>

      <h3 className="text-center widget-title" style={{ ...style.title, minHeight: '16px' }}>
        {translation.key('modalTitle')}
      </h3>

      <p className="mt0 description-title">{translation.key('descriptionModal')}</p>
      <div>
        <VariantsBlock
          productTitle={productTitle}
          variants={variants}
          selectedTimeSlot={timeSlotSelected}
          selectedTimeSlots={selectedTimeSlots}
          selectedResource={selectedResource}
          selectedLocation={selectedLocation}
          locale={locale}
          timeZone={timeZone}
          timeFormat={setting.time_format}
          selectDifferentTime={closeModal}
          enableResourceDropdown={enableResourceDropdown}
          enableLocationDropdown={enableLocationDropdown}
          isDisableFinishDate={!stringToBoolean(setting.display_time_range)}
          style={style}
        />
        {enabledBookingCreation
          && (
          <CustomerInfo
            getValidationFn={(validationFn) => getValidationFn('customer', validationFn)}
          />
          )}
        {showLocationMap && location && <LocationBlock style={style} selectedLocation={location} mapUrl={mapUrl} />}
        {enabledBookingFields
          && (
          <BookingFieldsBlock
            translation={translation}
            getValidationFn={(validationFn) => getValidationFn('additional', validationFn)}
            willUpdate={() => setWrapperHeight()}
            timeZone={timeZone}
            timeInterval={timeInterval}
            dateFormat={dateFormat}
          />
          )}
        <Price style={{ ...style.body }} title={translation.key('price')} />
      </div>
      <div>
        {renderSubmitButton(canBook)}
      </div>
      <TimeZone timeZone={timeZone} selectedTime={selectedTime} />
    </div>
  );
}
